import React from 'react';
import {
  Text,
  List,
  ListItem,
  CTA,
  styled,
  TextTag,
  TokenTextAppearance,
  Breakpoints,
} from '@volkswagen-onehub/components-core';
import ResultGallery from './ResultGallery';
import ResultBuild from './ResultBuild';
import { ResultModel } from '../../types/results';
import { useFeatureServices } from '../../use-feature-services';
const ResultModelContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${(props) => props.theme.size.dynamic0140};

  width: 100%;
  margin: ${(props) => props.theme.size.grid002} auto 0;

  @media screen and (min-width: ${Breakpoints.b960}px) {
    padding-left: ${(props) => props.theme.size.grid002};
  }
`;

const ResultDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* column-gap: ${(props) => props.theme.size.dynamic0150}; */
  row-gap: ${(props) => props.theme.size.dynamic0250};
  align-items: center;

  @media screen and (min-width: 768px) {
    flex-direction: row;
  }
`;

const ResultTitleContainer = styled.div``;

const ResultBodyContainer = styled.div``;

const HighlightContainer = styled.div``;

const ResultDescriptionContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.size.dynamic0040};
  padding: 0 ${(props) => props.theme.size.grid001};

  a {
    font-size: 1.2rem;
    font-weight: bold;
  }
`;

interface ResultModelInterface {
  result: ResultModel;
}

const ResultModel: React.FC<ResultModelInterface> = ({result}) => {
  const { tracking } = useFeatureServices();

  const handleLearnClick = (e: React.SyntheticEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    tracking.track('VWBasic_Link_Click', {
      configuration: {
        CarlineName: result.carlineName
      },
      link: {
        url: result.cta.learn.url,
        name: result.cta.learn.linkName
      }
    });

    window.open(result.cta.learn.url, '_self');
  };

  return (
    <ResultModelContainer>
      <ResultDetailsContainer>
        <ResultDescriptionContainer>
          <ResultTitleContainer>
            <Text
              tag={TextTag.h3}
              appearance={TokenTextAppearance.headline300}
              bold
            >
              {result.title}
            </Text>

            <Text tag={TextTag.h3} appearance={TokenTextAppearance.headline300}>
              {result.subTitle}
            </Text>
          </ResultTitleContainer>

          <ResultBodyContainer>
            <Text tag={TextTag.p}>{result.descriptions}</Text>
          </ResultBodyContainer>

          <HighlightContainer>
            <List>
              {result.highlights.map((highlight, index) => (
                <ListItem key={'highlight' + index}>{highlight}</ListItem>
              ))}
            </List>
          </HighlightContainer>

          <CTA
            tag="a"
            emphasis="tertiary"
            href={result.cta.learn.url}
            aria-label={result.cta.learn.title}
            onClick={handleLearnClick}
          >
            {result.cta.learn.title}
          </CTA>
        </ResultDescriptionContainer>

        <ResultGallery images={result.images} />
      </ResultDetailsContainer>

      <ResultBuild result={result} />
    </ResultModelContainer>
  );
};

export default ResultModel;
